import { useRef, useState } from "react";
import { UploadCloud, FileText, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";

export function DocxDropzone({ onUpload, onSample, busy }) {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);

  const handleFiles = (files) => {
    const file = files?.[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".docx")) {
      toast.error("Bitte eine .docx-Datei auswählen.");
      return;
    }
    onUpload(file);
  };

  return (
    <div className="flex flex-col gap-4">
      <div
        data-testid="docx-dropzone"
        onClick={() => !busy && inputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setDrag(true);
        }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDrag(false);
          handleFiles(e.dataTransfer.files);
        }}
        className={`relative cursor-pointer rounded-2xl border-2 border-dashed p-8 sm:p-10 text-center transition-all ${
          drag
            ? "border-blue-500 bg-blue-50 dark:bg-blue-950/30"
            : "border-slate-300 dark:border-slate-700 hover:border-blue-400 hover:bg-slate-50 dark:hover:bg-slate-800/40"
        }`}
      >
        <input
          ref={inputRef}
          data-testid="docx-file-input"
          type="file"
          accept=".docx"
          className="hidden"
          onChange={(e) => handleFiles(e.target.files)}
        />
        <div className="mx-auto grid place-items-center h-14 w-14 rounded-full bg-[#0F2942] dark:bg-blue-600 text-white mb-4">
          {busy ? <Loader2 className="h-6 w-6 animate-spin" /> : <UploadCloud className="h-6 w-6" />}
        </div>
        <p className="font-display text-lg font-semibold text-slate-900 dark:text-slate-100">
          {busy ? "Wird verarbeitet…" : "Word-Dokument hier ablegen"}
        </p>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          oder klicken zum Auswählen
        </p>
        <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-slate-100 dark:bg-slate-800 px-3 py-1 text-xs font-medium text-slate-600 dark:text-slate-300">
          <FileText className="h-3.5 w-3.5" /> Nur .docx
        </span>
      </div>

      <button
        data-testid="sample-document-button"
        onClick={onSample}
        disabled={busy}
        className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-4 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50"
      >
        <Sparkles className="h-4 w-4 text-amber-500" />
        Beispiel-Dokument laden (Treu und Glauben)
      </button>
    </div>
  );
}
